document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll('.animation-scroll-inner');
  if (!sections.length) return;

  gsap.registerPlugin(ScrollTrigger);

  sections.forEach((section) => {
    const els = Array.from(section.querySelectorAll('.animation-scroll'));

    els.forEach((el) => {

      ScrollTrigger.create({
        trigger: el,
        start: 'top top+=15%',
        endTrigger: section,
        end: () => 'bottom top+=' + (window.innerHeight * 0.15 + el.offsetHeight),
        pin: el,
        pinSpacing: false,
      });
    });
  });
});
